<div *ngIf="!reportText.editMode" class="resize-marker-container" [style.top]="reportText.top"
  [style.left]="reportText.left" [style.width]="reportText.width" [style.height]="reportText.height" [ngClass]="{'draw-custom-element':isCustomDrawEnable || reportText.isCustomElement()}">

  <div *ngIf="reportText.isSelected" class="resize LT" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('top')"
    [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'top', 'left')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportText.isSelected" class="resize CT" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('top')"
    [style.left]="getResizeMarkerLeft('center')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'top', 'center')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportText.isSelected" class="resize RT" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('top')"
    [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'top', 'right')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>

  <div *ngIf="reportText.isSelected" class="resize LM" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('middle')"
    [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'middle', 'left')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportText.isSelected" class="resize RM" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('middle')"
    [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'middle', 'right')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>

  <div *ngIf="reportText.isSelected" class="resize LB" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('bottom')"
    [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'bottom', 'left')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportText.isSelected" class="resize CB" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('bottom')"
    [style.left]="getResizeMarkerLeft('center')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'bottom', 'center')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportText.isSelected" class="resize RB" [style.width]="getResizeMarkerSize()"
    [style.height]="getResizeMarkerSize()" [style.top]="getResizeMarkerTop('bottom')"
    [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportText.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'bottom', 'right')" (mousemove)="onResizing($event)"
    (mouseup)="onResizeMarkerUp($event)" (mouseleave)="onResizeMarkerLeave($event)"></div>
</div>

<div [ngClass]="{
    'report-text': true,
    'selectable': reportText.isSelectable && !reportText.editMode,
    'edited': !reportText.isSaved() && !reportText.editMode,
    'selected': reportText.isSelected && !reportText.editMode,
    'editable-mark': reportText.isGuideMarkType('editable') && !reportText.editMode,
    'dynamic-mark': reportText.isGuideMarkType('dynamic') && !reportText.editMode,
    'static-mark': reportText.isGuideMarkType('static') && !reportText.editMode,
    'highlight-hover' : designService.highlightElement,
    'draw-custom-element':isCustomDrawEnable || reportText.isCustomElement()
  }" [style.left]="reportText.left" [style.top]="reportText.top"
     [style.width]="reportText.width" [style.height]="reportText.height" [style.zIndex]="reportText.zIndex"
     (click)="onClick($event)" draggable="true"
     (dragstart)="onDragStart($event)" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
     (dblclick)="enableEditMode(reportText)">
  <div *ngIf="!reportText.editMode" [ngClass]="{
        'report-text-inline': true,
        'report-text-vertical': !reportText.isHorizontal && isVisol
        }" [style.width]="reportText.width" [style.height]="reportText.height">
    <div [ngClass]="{'report-text-cell': true}"
         [style.fontSize]="reportText.fontSize" [style.fontFamily]="reportText.fontFamily" [style.color]="reportText.color"
         [style.fontStyle]="reportText.fontStyle" [style.fontWeight]="reportText.fontWeight" [style.lineHeight]="reportText.lineHeight"
         [style.backgroundColor]="reportText.backgroundColor" [style.borderStyle]="reportText.borderStyle" [style.borderWidth]="reportText.borderWidth" [style.borderColor]="reportText.borderColor"
         [style.textAlign]="reportText.textAlign" [style.verticalAlign]="reportText.verticalAlign"
         [style.paddingRight]="reportText.paddingRight" [style.paddingBottom]="reportText.paddingBottom" [style.paddingLeft]="reportText.paddingLeft" [style.paddingTop]="reportText.paddingTop">
      {{ reportText.previewLabel }}
    </div>
  </div>

  <div *ngIf="reportText.editMode" [ngClass]="{
        'report-text-inline': true,
        'report-text-vertical': !reportText.isHorizontal && isVisol
        }" [style.width]="reportText.width" [style.height]="reportText.height">
    <div [ngClass]="{'report-text-cell': true}"
         [style.fontSize]="reportText.fontSize" [style.fontFamily]="reportText.fontFamily" [style.color]="reportText.color"
         [style.fontStyle]="reportText.fontStyle" [style.fontWeight]="reportText.fontWeight" [style.lineHeight]="reportText.lineHeight"
         [style.backgroundColor]="reportText.backgroundColor" [style.borderStyle]="reportText.borderStyle" [style.borderWidth]="reportText.borderWidth" [style.borderColor]="reportText.borderColor"
         [style.textAlign]="reportText.textAlign" [style.verticalAlign]="reportText.verticalAlign"
         [style.paddingRight]="reportText.paddingRight" [style.paddingBottom]="reportText.paddingBottom" [style.paddingLeft]="reportText.paddingLeft" [style.paddingTop]="reportText.paddingTop"
         (blur)="disableEditMode(reportText)" [(ngModel)]="reportText.text">
      {{ reportText.previewLabel }}
    </div>
  </div>
</div>
